// -*- Mode: rjsx -*-
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Link } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import CircularProgress from '@mui/material/CircularProgress';

import { FHTheme, FHMaterialStyles } from '../../../ui';

import { loadQueue } from '../../queue';


function QueueStatusRequest(props) {
    //    if(!props.request.key) return <em>none</em>;
    const request = props.request;
    
    if(!request.key) return null;
    
    return (
        <>
          <Link to="/queue" style={{ color: "black" }} >
            Back to Queue 
          </Link>
        </>
    );

}


function BackToQueue(props) {
    return (
        <Link to="/queue" style={{ textDecoration: "none" }} >
          <Button startIcon={<ArrowBackIcon />} size="small" variant="outlined" color="primary">
            Back to Queue
          </Button>
        </Link>        
    );
}

function QueueSize(props) {
    const classes = FHMaterialStyles();
    
    // return (
    //     <>
    //         <Chip label={props.size + " item" + (props.size == 1 ? '' : 's') + " in your queue"} />
    //     </>
    // );

    return (
        <Tooltip arrow title="This is how many things you've got to work on.">
          <div className={classes.hudBarQueueSize}>
            {props.size + " item" + (props.size == 1 ? '' : 's') + " in your queue"}
          </div>
        </Tooltip>
    );
}

function QueueStatus(props) {
    const request = useSelector((state) => state.requests.current);
    const queueStatus = useSelector( (state) => state.queue.status );
    const queueSize = useSelector((state) => {
        // console.log("state.queue: %o", state.queue);
        return state.queue.entities.length;
    });
    const isLoading = queueStatus === 'loading';
    const dispatch = useDispatch();
    
    // console.log("qu status request: %o", request);
    // console.log("qu status size: %o", queueSize);

    // useEffect(() => {
    //     dispatch(loadQueue()).
    //         then((data) => {
    //             console.log("data: %o", data);
    //         });
    // }, []);

    if (isLoading)
        return <CircularProgress />;
    return null;
    // if (request.key)
    //     return <BackToQueue />;
    // else
    //     return <QueueSize size={queueSize} />;
    
}

function Bar(props) {

    const classes = FHMaterialStyles();
    
	return (
      <Grid
        className={classes.hudContainer}
        container
        spacing={2}
        direction="row"
        alignItems="center"
        justifyContent="space-between" >

        
        <Grid item >{/* style={{ border: "solid 1px red" }}> */}
          <QueueStatus />
        </Grid>
        
        
        <Grid item>  {/* style={{ border: "solid 1px red" }}> */}

          <Grid container  alignItems="center" className={classes.moneyContainer}>
            <Grid item>
              <MonetizationOnIcon style={{ fontSize: "200%", paddingTop: 3 }}/>
            </Grid>
            <Grid item style={{ fontSize: "200%" }} className={classes.moneyText}>
              26.78
            </Grid>
            
          </Grid>
          
        </Grid>
      </Grid>
    );
}

export { Bar };
